import React, { useState } from 'react';
import ConfirmModal from '../ConfirmModal';
import { getSantiagoDateKey } from '../../utils/priceListPromotions';
import { buildBranchStockLimit } from './PromotionDateRangeDialog';
import { isWeightOffer } from './OfferAvailabilityDialog';

const inputClass = 'mt-1 block min-h-11 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm disabled:bg-slate-100';

const EditPriceListOfferDialog = ({ target, saving, error, onClose, onSubmit }) => {
  const { format, product, variety } = target;
  const policy = format.offerAvailability;
  const started = Date.parse(policy.startsAt || policy.enabledAt) <= Date.now();
  const weight = isWeightOffer(format);
  const [form, setForm] = useState({ sellingPrice: String(format.sellingPrice ?? ''),
    startDate: getSantiagoDateKey(policy.startsAt || policy.enabledAt),
    endDate: getSantiagoDateKey(new Date(Date.parse(policy.expiresAt) - 1)),
    stock: policy.maxQuantity == null ? '' : String(policy.maxQuantity),
    tolerance: policy.tolerance == null ? '' : String(policy.tolerance) });
  const [validation, setValidation] = useState('');
  const change = (field, value) => { setForm((current) => ({ ...current, [field]: value })); setValidation(''); };
  const submit = () => {
    if (saving) return;
    try {
      const sellingPrice = Number(form.sellingPrice);
      if (!Number.isSafeInteger(sellingPrice) || sellingPrice <= 0 || sellingPrice > 2147483647) throw new Error('Ingresa un precio entero mayor a 0.');
      if (!form.startDate || !form.endDate || form.endDate < form.startDate || form.endDate < getSantiagoDateKey()) throw new Error('Indica fechas válidas; el término debe ser hoy o después.');
      const limits = buildBranchStockLimit(form);
      if (limits.maxQuantity != null && !weight && !Number.isInteger(limits.maxQuantity)) throw new Error('El stock debe ser un número entero.');
      if (limits.maxQuantity != null && Number(policy.soldQuantity || 0) >= limits.maxQuantity - Number(limits.tolerance || 0)) throw new Error('El stock máximo menos la tolerancia debe superar la cantidad ya vendida.');
      setValidation('');
      onSubmit({ sellingPrice, startDate: form.startDate, endDate: form.endDate, ...limits,
        expectedEnabledAt: policy.enabledAt, acknowledgePolicyWarnings: true });
    } catch (failure) { setValidation(failure.message); }
  };
  return <ConfirmModal isOpen title="Editar Oferta" message={`${product.name} · ${variety.name}`}
    confirmLabel={saving ? 'Guardando…' : 'Guardar cambios'} confirmDisabled={saving}
    onCancel={() => { if (!saving) onClose(); }} onConfirm={submit}>
    <div className="mt-4 max-h-[60dvh] overflow-y-auto pr-1">
      <fieldset disabled={saving} className="space-y-3">
        <label className="block text-sm text-slate-700">Precio de Oferta ($)
          <input aria-label="Precio de Oferta" type="number" min="1" max="2147483647" step="1" inputMode="numeric"
            value={form.sellingPrice} disabled={format.isPriceLocked} onChange={(e) => change('sellingPrice', e.target.value)} className={inputClass} />
        </label>
        {format.isPriceLocked && <p className="text-xs text-slate-600">Desbloquea el formato Oferta para cambiar su precio.</p>}
        <div className="grid grid-cols-2 gap-3">
          <label className="block text-sm text-slate-700">Inicio
            <input aria-label="Inicio de Oferta" type="date" value={form.startDate} disabled={started}
              onChange={(e) => change('startDate', e.target.value)} className={inputClass} />
          </label>
          <label className="block text-sm text-slate-700">Último día
            <input aria-label="Último día de Oferta" type="date" min={getSantiagoDateKey()} value={form.endDate}
              onChange={(e) => change('endDate', e.target.value)} className={inputClass} />
          </label>
        </div>
        <p className="text-xs text-slate-600">Vigente hasta el final del último día, en hora de Chile.</p>
        <label className="block text-sm text-slate-700">Stock máximo ({policy.unit || format.metricUnit}) · opcional
          <input aria-label="Stock máximo de Oferta" type="number" min={weight ? '0.001' : '1'} step={weight ? '0.001' : '1'}
            value={form.stock} onChange={(e) => { change('stock', e.target.value); if (!e.target.value) change('tolerance', ''); }} className={inputClass} />
        </label>
        {form.stock !== '' && <label className="block text-sm text-slate-700">Tolerancia ({policy.unit || format.metricUnit})
          <input aria-label="Tolerancia de Oferta" type="number" min="0" step="0.00001" value={form.tolerance}
            onChange={(e) => change('tolerance', e.target.value)} className={inputClass} />
        </label>}
        <p className="text-xs text-slate-600">Ya vendidos: {Number(policy.soldQuantity || 0).toLocaleString('es-CL')} {policy.unit || format.metricUnit}. El contador de ventas y la disponibilidad de Detalle se conservan.</p>
      </fieldset>
      {(validation || error) && <p role="alert" className="mt-3 text-sm font-semibold text-red-700">{validation || error}</p>}
    </div>
  </ConfirmModal>;
};
export default EditPriceListOfferDialog;
